import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleCloth } from '../../../Store/PHPSlice/Cloth';
import { Button } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';
import axios from 'axios';


const TableBody = ({
    serialNumber,
    id,
    pono,
    dt,
    partyNm,
    firmNm,
    amt,
    shifto,
    refer,
    partyId,
    firmId,
    totqty,
    totmtr,
    taxamt,
    finalamt,
    insts,
    sts,
    selected,
    handleClick,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Do you really want to delete this PO?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteMaterialPOReg(id, userdata?.ID);
        }
    };

    const handleViewClick = () => {
        window.open(`/material-po-view-new/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const deleteMaterialPOReg = async (id, userid) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteMaterialPOReg&poId=${id}&userId=${userid}`);
            // console.log(res);
            if (res.data.status === "success") {
                alert(res.data.msg);
                window.location.reload();
            } else {
                alert(res.data.msg);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {pono}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {amt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {finalamt}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sts === '1' ? <button className='sts-btn-updated'>Updated</button> : <button className='sts-btn-pending'>Pending</button>}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${insts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
